import React from 'react';
import { motion } from 'framer-motion';
import Header from '../page/Header';
import Footer from '../page/Footer';
import ServicesPage from '../page/ServicesPage';
import JoinButton from '../buttons/JoinButton';
import Project from '../page/Project';
import ChatBot from '../page/Chatbot';

export default function BudgetCalculate() {
  

  return (
    <>
     

 
      <ChatBot/>
    
    </>
  );
}

